// Generated by scripts/build-ui-icons.mjs.
export { Toilet as default } from "../ui/glyphs-7";
